export const nav = {
    permissao: 'hdocs.tipos-documento:ver',
    section: 'Configuracao',
    title: 'TiposDocumento',
    icon: 'description',
    route: '/tipos-documento',
    sequence: 11, // ver comentario em modules/categorias/routes.js
};

export default [
    {
        path: '/tipos-documento',
        name: 'tipos-documento',
        component: () => import('./pages/TiposDocumentoPage.vue'),
        meta: { requiresAuth: true, permissao: 'hdocs.tipos-documento:ver' },
    },
    {
        path: '/tipos-documento/novo',
        name: 'tipos-documento-novo',
        component: () => import('./pages/TipoDocumentoFormPage.vue'),
        meta: { requiresAuth: true, permissao: 'hdocs.tipos-documento:criar' },
    },
    {
        path: '/tipos-documento/:id/editar',
        name: 'tipos-documento-editar',
        component: () => import('./pages/TipoDocumentoFormPage.vue'),
        props: true,
        meta: { requiresAuth: true, permissao: 'hdocs.tipos-documento:editar' },
    },
];
